import React from 'react';
import * as S from './IconLeft.styles';
export const IconLeft = _ref => {
  let {
    children,
    className
  } = _ref;
  if (!children) return null;
  return React.createElement(S.Wrapper, {
    className: className
  }, children);
};
IconLeft.displayName = 'IconLeft';